module.exports = __webpack_public_path__ + "857dd095ce0528b78b936931840c0f31.woff";